import { useCallback, useState } from "react";
import type { Report } from "../../../../../../../../api/types/svTypes.ts";
import useCurrentReportConfiguration from "../../../../hooks/useCurrentReportConfiguration";
import { getPreconditionFailedMessage } from "../../../../utilities/getPreconditionFailedMessage.ts";

interface Props {
  report: Report;
  addReport: (report: Report) => Promise<Report | undefined>;
  onChanged: (reportId: string) => void;
  onClose: () => void;
}

const useSaveReportAsDialog = ({ addReport, onChanged, report, onClose }: Props) => {
  const [error, setError] = useState<string>();
  const [saving, setSaving] = useState(false);

  const { getCurrentReportConfigurationAsync } = useCurrentReportConfiguration();

  const handleSaveClicked = useCallback(
    async (name: string, groupId: string) => {
      const reportConfiguration = (await getCurrentReportConfigurationAsync()) ?? report.configuration;
      setSaving(true);
      const rep = { ...report, name, groupId, configuration: reportConfiguration } as Report;

      addReport(rep)
        .then((response) => {
          setSaving(false);
          onChanged(response?.reportId || "");
          onClose();
        })
        .catch((error: unknown) => {
          setError(getPreconditionFailedMessage(error) ?? " An error occurred while duplicating the report.");
          setSaving(false);
        });
    },
    // eslint-disable-next-line @eslint-react/exhaustive-deps
    [getCurrentReportConfigurationAsync, onChanged, report]
  );

  return {
    error,
    saving,
    handleSaveClicked,
  };
};

export default useSaveReportAsDialog;
